import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getMessageTemplates } from "../../network/lib/masterData.js";
import { get, memberObject, save } from "../../network/lib/member.js";
import { showHideLoader } from "../utils/helper.js";
import {
  getMessageTemplateById,
  messageObject,
  send,
} from "../../network/lib/message.js";
import { ReactTransliterate } from "react-transliterate";

function Message({ user }) {
  const navigate = useNavigate();
  const [templates, setTemplates] = useState();
  const [template, setTemplate] = useState(0);
  const [initialTemplateDescription, setInitialTemplateDescription] =
    useState("");
  const [finalTemplateDescription, setFinalTemplateDescription] = useState("");
  const [isSingle, setIsSingle] = useState(false);
  const [memberId, setMemberId] = useState(0);
  const [userDetails, setUserDetails] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    !templates &&
      getMessageTemplates().then((resp) => {
        resp.status == 200 && setTemplates(resp.data);
      });
    processInitial();
  }, []);

  const fetchRecord = (pageNumber) => {
    get({
      isMessageSubscriped: true,
      pageNumber: pageNumber,
      pageSize: 10,
    }).then((res) => {
      if (res.status == 200 && res.data) {
        setUserDetails(res.data.records);
        setCurrentPage(pageNumber);
        setTotalPages(Math.ceil(res.data.total / 10));
      }
    });
  };

  const processInitial = () => {
    let item = localStorage.getItem("sendMessage");
    if (item) {
      localStorage.removeItem("sendMessage");
      let data = JSON.parse(item);
      if (data) {
        setIsSingle(data.single);

        if (data.user) {
          setMemberId(data.user.id);
          setUserDetails([data.user]);
        } else {
          fetchRecord(1);
        }
      }
    } else navigate("/admin/searchmember");
  };

  const setToDefault = () => {
    setTemplate(0);
    setInitialTemplateDescription("");
    setFinalTemplateDescription("");
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetMessage();
    setToDefault();
    navigate("/admin/searchmember");
  };

  const resetMessage = () => {
    let message = document.getElementById("message");
    message.innerHTML = "";
    message.classList.replace("success", "alert");
    return message;
  };

  const defaultValueForFinalTemplateDescription =
    'Please replace all placeholder named "{{{placeholder}}}" with valid value';

  const handleTemplateSelection = (e) => {
    const value = e.target.value;
    setTemplate(value);

    getMessageTemplateById(parseInt(value)).then((x) => {
      if (x.status == 200 && x.data) {
        setInitialTemplateDescription(x.data.description);
        setFinalTemplateDescription(defaultValueForFinalTemplateDescription);
      } else if (x.status == 204) {
        setInitialTemplateDescription("");
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let message = resetMessage();

    if (template == "0" || template == 0) {
      message.innerHTML = "Please select valid Template";
    } else {
      showHideLoader(true);

      messageObject.isSingle = isSingle;
      messageObject.templateId = template;
      messageObject.description = finalTemplateDescription;
      messageObject.memberId = memberId;
      messageObject.userName = user.userName;

      send(messageObject).then((res) => {
        if (res.status == 200 && res.data) {
          message.classList.replace("alert", "success");
          message.innerHTML = `Message sent successfully!!!`;
        } else {
          message.innerHTML = "Some error occurred. Please try again";
        }
        setToDefault();
        showHideLoader();
      });
    }
  };

  const contents = (
    <>
      <table>
        <tbody>
          <tr>
            <td colSpan={2}></td>
            <td align="right">
              <Link to="/admin/searchmember">
                <span>Search Member</span>
              </Link>
            </td>
          </tr>
          <tr>
            <th align="center" colSpan="4">
              Message Panel
            </th>
          </tr>
          <tr>
            <td align="right">
              <span className="required">Template</span>
            </td>
            <td colSpan={3}>
              {templates && (
                <select onChange={handleTemplateSelection} value={template}>
                  <option value="0">Select</option>
                  {templates.map((x, i) => (
                    <option key={i} value={x.id}>
                      {x.name}
                    </option>
                  ))}
                </select>
              )}
            </td>
          </tr>
          <tr>
            <td align="right">
              <span>Description</span>
            </td>
            <td>
              <ReactTransliterate
                renderComponent={(props) => (
                  <textarea {...props} rows="5" cols="50" />
                )}
                value={initialTemplateDescription}
                onChangeText={(e) => {
                  setInitialTemplateDescription(e);
                  setFinalTemplateDescription(
                    !e.includes("{{{placeholder}}}")
                      ? e.trimEnd()
                      : defaultValueForFinalTemplateDescription
                  );
                }}
                lang="mr"
              />
            </td>
            <td>
              <textarea
                value={finalTemplateDescription}
                onChange={(e) => setFinalTemplateDescription(e.target.value)}
                rows={5}
                cols={50}
                disabled={true}
              />
            </td>
          </tr>
          <tr>
            <td></td>
            <td
              colSpan={2}
              style={{ textAlign: "right", paddingRight: "25px" }}
            >
              <input
                className="btn"
                type="submit"
                value="Cancel"
                id="btnCancel"
                onClick={handleCancel}
              />
              &nbsp;&nbsp;
              {userDetails &&
              finalTemplateDescription &&
              !finalTemplateDescription.includes("{{{placeholder}}}") ? (
                <input
                  className="btn"
                  type="submit"
                  value="Send"
                  id="btnSubmit"
                  onClick={handleSubmit}
                />
              ) : (
                <></>
              )}
            </td>
            <td></td>
          </tr>
          <tr>
            <td colSpan="4" style={{ textAlign: "center" }}>
              <div
                id="message"
                className="alert"
                style={{ textAlign: "center" }}
              ></div>
            </td>
          </tr>
        </tbody>
      </table>
      {userDetails && (
        <table className="alternate-row">
          <thead>
            <tr>
              <th align="center" colSpan="5">
                Members
              </th>
            </tr>
            <tr>
              <td colSpan={5}></td>
            </tr>
          </thead>
          <tbody>
            <tr style={{ textAlign: "center" }}>
              <td>
                <u>Id</u>
              </td>
              <td>
                <u>Name</u>
              </td>
              <td>
                <u>Mobile</u>
              </td>
              <td>
                <u>Date of Birth</u>
              </td>
              <td>
                <u>Date of Joining</u>
              </td>
            </tr>
            {userDetails.map((x, i) => (
              <tr key={i} style={{ textAlign: "center" }}>
                <td>{x.id}</td>
                <td>{x.name}</td>
                <td>{x.mobile}</td>
                <td>{x.dateOfBirth}</td>
                <td>{x.dateOfJoining}</td>
              </tr>
            ))}
          </tbody>
          {totalPages > 1 && (
            <tfoot>
              <tr>
                <td align="center" colSpan="5">
                  <input
                    className="btn"
                    type="button"
                    onClick={() => fetchRecord(currentPage - 1)}
                    disabled={currentPage === 1}
                    value="Previous"
                  />
                  <span>
                    &nbsp;&nbsp;Page {currentPage} of {totalPages}
                  </span>
                  <input
                    className="btn"
                    type="button"
                    onClick={() => fetchRecord(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    value="Next"
                  />
                </td>
              </tr>
            </tfoot>
          )}
        </table>
      )}
    </>
  );

  return contents;
}

export default Message;
